import React from 'react'
import style from './style.module.scss'

const Radio = ({ value, onChange, checked = false, ...props }) => {
  return (
    <label className={style.container}>
      <input
        type="checkbox"
        className={style.input}
        value={value}
        onChange={onChange}
        checked={checked}
      />

      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={style.checkmark}
      >
        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#4C70EF" />
        <rect x="3" y="3" width="10" height="10" rx="3.5" fill="#4C70EF" />
      </svg>

      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={style.un_checkmark}
      >
        <rect
          x="0.5"
          y="0.5"
          width="15"
          height="15"
          rx="3.5"
          stroke="#A4A3A8"
        />
      </svg>
    </label>
  )
}

export default Radio